/* eslint-disable array-callback-return */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Tooltip, Checkbox, Radio, Popconfirm, Alert,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import ProductActions from '@Actions/productActions';
import Helpers from '@Apis/helpers';
import {
  DEFAULT_CUR_ROUND_OFF,
  QUANTITY, toISTDate,
} from '@Apis/constants';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import { CloseOutlined } from '@ant-design/icons';

/**
 *
 */
function CalculateBulkSp({
  user, MONEY, selectedRows, bulkUpdateProductsLoading, bulkUpdateProducts, callback,
}) {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [globalMargin, setGlobalMargin] = useState(10);
  const [cpType, setCpType] = useState('WEIGHTED_AVERAGE_BATCH_CP');
  const [isShopifyUpdateReqd, setIsShopifyUpdateReqd] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);
  /**
     *
     * @returns {[{responsive: string[], width: string, title: string, render: (function(*, *))},{responsive: string[], title: string, render: (function(*))},{responsive: string[], title: string, render: (function(*, *): *)},{responsive: string[], title: string, render: (function(*, *): *)},{responsive: string[], title: string, render: (function(*, *): *)}]}
     */
  const getProductColumns = () => {
    const columns = [
      {
        title: 'PRODUCT',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        width: '220px',
        render: (text, record) => (
          <Fragment>
            <H3Text text={`#${record?.product_info?.internal_sku_code}`} className="table-subscript" />
            <H3Text text={`${record?.product_info?.ref_product_code ? `${record?.product_info?.ref_product_code} - ` : ''}${record?.product_info?.product_sku_name}`} className="prod-table__text" />
            {(record.product_type !== 'STORABLE' && record.product_type) && (
              <div className="inventory-qr__status" style={{ backgroundColor: Helpers.getProductType(record.product_type)?.color }}>{Helpers.getProductType(record.product_type)?.text}</div>
            )}
          </Fragment>
        ),
      },
      {
        title: 'STOCK IN DEFAULT DEPT',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <Fragment>
            {
              ['STORABLE', 'BUNDLE'].includes(record?.product_type?.toUpperCase()) ? (
                <div style={{ cursor: 'pointer' }}>{`${QUANTITY(record?.store_stock || '0', record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`}</div>
              ) : '-'
            }
          </Fragment>
        ),
      },
      {
        title: 'COST PRICE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => MONEY(record?.cost_price),
      },
      {
        title: 'WEIGHTED AVG BATCH CP',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => MONEY(record?.avg_batch_cost_price),
      },
      {
        title: 'CURRENT SP',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => MONEY(record?.selling_price),
      },
      {
        title: 'MARGIN',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        width: '100px',
        render: (record) => (
          <H3FormInput
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(e) => {
              const productsCopy = JSON.parse(JSON.stringify(selectedProducts));
              for (let i = 0; i < selectedProducts?.length; i++) {
                if (selectedProducts[i]?.key === record?.key) {
                  const cp = (cpType === 'COST_PRICE' ? productsCopy[i].cost_price : productsCopy[i].avg_batch_cost_price);
                  productsCopy[i].margin = Number(e.target.value);
                  productsCopy[i].new_selling_price = Number((cp * (1 + (Number(e.target.value) / 100)))?.toFixed(DEFAULT_CUR_ROUND_OFF));
                }
              }
              setSelectedProducts(productsCopy);
            }}
            value={record?.margin}
            required
            showError={formSubmitted && !record?.margin}
          />
        ),
      },
      {
        title: 'NEW SELLING PRICE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        width: '140px',
        render: (record) => (
          <H3FormInput
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(e) => {
              const productsCopy = JSON.parse(JSON.stringify(selectedProducts));
              for (let i = 0; i < selectedProducts?.length; i++) {
                if (selectedProducts[i]?.key === record?.key) {
                  const sp = Number(e.target.value);
                  const cp = (cpType === 'COST_PRICE' ? productsCopy[i].cost_price : productsCopy[i].avg_batch_cost_price);
                  productsCopy[i].new_selling_price = sp;
                  productsCopy[i].margin = Number((((sp - cp) / sp) * 100)?.toFixed(DEFAULT_CUR_ROUND_OFF));
                }
              }
              setSelectedProducts(productsCopy);
            }}
            value={record?.new_selling_price}
            required
            showError={formSubmitted && !record?.new_selling_price}
          />
        ),
      },
    ];
    if (user?.tenant_info?.shopify_location_id) {
      columns.push({
        title: '',
        key: 'action4',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.shopify_location_id && (
            <div>
              {record?.product_info?.shopify_parent_id
                && (
                  <Tooltip title={`Last sync ${toISTDate(record?.product_info?.shopify_updated_at).format('DD/MM/YYYY hh:mm A')}`} overlayClassName="font-12" placement="topRight">
                    <a href={`https://admin.shopify.com/store/${record?.product_info?.shopify_shop_name?.split('.')?.[0]}/products/${record?.product_info?.shopify_parent_id}/variants/${record?.product_info?.shopify_variant_id}`} target="_blank" rel="noreferrer">
                      <div className="img-shopify_product-wrapper">
                        <img
                          src={ShopifyIcon}
                          alt="Shopify"
                          className="img-shopify_product"
                        />
                      </div>
                    </a>
                  </Tooltip>
                )}
            </div>
          )
        ),
      });
    }
    columns.push({
      title: '',
      render: (text, record) => (
        <Fragment>
          <Fragment>
            <Popconfirm
              title="Are you sure you want to remove this product?"
              onConfirm={() => setSelectedProducts(selectedProducts?.filter((item) => item?.key !== record?.key))}
              onCancel={() => { }}
              okText="Yes"
              cancelText="No"
            >
              <div className="calculate-sp__delete-button">
                <CloseOutlined />
              </div>
            </Popconfirm>
          </Fragment>

        </Fragment>
      ),
      width: '40px',
    });

    return columns;
  };

  const recalculatePrices = (products) => {
    if (products?.length) {
      const productsCopy = JSON.parse(JSON.stringify(products));
      for (let i = 0; i < productsCopy?.length; i++) {
        productsCopy[i].key = i;
        productsCopy[i].margin = globalMargin;
        productsCopy[i].new_selling_price = Number((cpType === 'COST_PRICE' ? productsCopy[i].cost_price * (1 + (globalMargin / 100)) : productsCopy[i].avg_batch_cost_price * (1 + (globalMargin / 100)))?.toFixed(DEFAULT_CUR_ROUND_OFF));
      }
      setIsShopifyUpdateReqd(products?.filter((item) => item?.product_info?.shopify_parent_id)?.length > 0);
      setSelectedProducts(productsCopy);
    }
  };

  useEffect(() => {
    setSelectedProducts(selectedRows);
    recalculatePrices(selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    recalculatePrices(selectedProducts);
  }, [globalMargin, cpType]);

  /**
     *
     * @return {JSX.Element}
     */
  return (
    <Fragment>
      <div className="calculate-sp__row">
        <H3Text text="Margin Percentage" className="calculate-sp__row-label" />
        <H3FormInput
          type="number"
          containerClassName="orgInputContainer"
          inputClassName="orgFormInput calculate-sp__row-input"
          onChange={(e) => {
            setGlobalMargin(Number(e.target.value));
          }}
          value={globalMargin}
          required
        />
      </div>
      <div className="calculate-sp__row">
        <H3Text text="Which price do you want to consider for calculating selling price?" className="calculate-sp__row-label" />
        <Radio.Group name="radiogroup" value={cpType} onChange={(e) => setCpType(e.target.value)}>
          <Radio value="WEIGHTED_AVERAGE_BATCH_CP">Weighted Average Batch Cost Price</Radio>
          <Radio value="COST_PRICE">Cost Price</Radio>
        </Radio.Group>
      </div>
      {selectedProducts?.filter((item) => item?.product_info?.shopify_parent_id)?.length > 0 ? (
        <div className="calculate-sp__row">
          <Checkbox onChange={() => setIsShopifyUpdateReqd(!isShopifyUpdateReqd)} checked={isShopifyUpdateReqd}>
            Update
            Selling Price in Shopify
            {' '}
          </Checkbox>
        </div>
      ) : ''}
      <div style={{ paddingBottom: '40px' }}>
        <Table
          showHeader
          size="small"
          scroll={{ x: 'max-content' }}
          columns={getProductColumns()}
          bordered
          dataSource={selectedProducts || []}
          pagination={false}
          rowClassName={(record) => (Number(record?.new_selling_price) <= 0 ? 'calculate-sp__row-warning' : '')}
        />
      </div>
      <div className="custom-drawer__footer" style={{ width: 'calc(100% - 50px)', display: 'flex', padding: '10px 0px !important' }}>
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text="Update Selling Price"
          onClick={() => bulkUpdateProducts({
            update_in_shopify: isShopifyUpdateReqd,
            tenant_products: selectedProducts?.map((item) => ({
              product_sku_id: item?.product_info?.product_sku_id,
              tenant_id: user?.tenant_info?.tenant_id,
              selling_price: item?.new_selling_price,
            })),
          }, () => {
            callback();
          })}
          isLoading={bulkUpdateProductsLoading}
          style={{
            width: '200px',
            borderRadius: '5px',
            padding: '7px 0px',
            marginLeft: '0',
          }}
        />
        {selectedProducts?.filter((item) => Number(item?.new_selling_price) <= 0)?.length > 0 ? (
          <Alert
            type="error"
            message={`Warning! ${selectedProducts?.filter((item) => Number(item?.new_selling_price) <= 0)?.length} products have zero selling price.`}
            showIcon
            className="calculate-sp__alert"
          />
        ) : ''}
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  bulkUpdateProductsLoading: ProductReducers.bulkUpdateProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  bulkUpdateProducts: (payload, callback) => dispatch(ProductActions.bulkUpdateProducts(payload, callback)),
});

CalculateBulkSp.propTypes = {
  user: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CalculateBulkSp));
